import React from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';

import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import SimilaritySearchGrid from '@Pages/RetroSynthesis/SimilaritySearch/SimilaritySearchGrid';
import isEmpty from 'lodash/isEmpty';
import { RsButton, RsButtonIcon, RsButtonIconType, RsButtonLabel } from '@Pages/RetroSynthesis/components/RsButton';

import './SimilaritySearchDialog.scss';

function SimilaritySearchDialog({
  onCancel,
  onLoadMore,
  onSubmitSubstance,
  similarResults,
  totalItems,
  isResultsLoading,
  isSimilarityLoading,
  error,
  title,
}) {
  return (
    <GeneralDialogLayout
      className="similarity-search-dialog"
      selfClose={() => onCancel()}
      header={<h4>{title}</h4>}
      footer={
        <div className="similarity-search-dialog__footer">
          <RsButton
            classNames="synthesize-btn-loader"
            disabled={isResultsLoading || isEmpty(similarResults) || similarResults.length >= totalItems}
            onClick={() => onLoadMore()}>
            <RsButtonIcon type={RsButtonIconType.PLUS} />
            <RsButtonLabel label="Load more" />
          </RsButton>
          <RsButton classNames="btn-cancel" onClick={() => onCancel()}>
            <RsButtonIcon type={RsButtonIconType.DELETE} />
            <RsButtonLabel label="Cancel" />
          </RsButton>
        </div>
      }>
      {/* eslint-disable-next-line no-nested-ternary */}
      {error ? (
        <div className="similarity-search-dialog__error">{(error && error.message) || 'Internal Error'}</div>
      ) : isSimilarityLoading ? (
        <SimpleSpinner />
      ) : (
        <SimilaritySearchGrid
          results={similarResults}
          onSubmit={onSubmitSubstance}
          totalItems={totalItems}
          isLoadingMore={isResultsLoading}
        />
      )}
    </GeneralDialogLayout>
  );
}

SimilaritySearchDialog.defaultProps = {
  onCancel: () => null,
  onSubmitSubstance: () => null,
  onLoadMore: () => null,
};

SimilaritySearchDialog.propTypes = {
  similarResults: PropTypes.array,
  onCancel: PropTypes.func,
  onSubmitSubstance: PropTypes.func,
  onLoadMore: PropTypes.func,
  title: PropTypes.string,
  totalItems: PropTypes.number,
  isResultsLoading: PropTypes.bool,
  isSimilarityLoading: PropTypes.bool,
  error: PropTypes.object,
};

export default SimilaritySearchDialog;
